
export const isLocalMode = process.env.REACT_APP_LOCAL_MODE === "true";
export const localLocationName = isLocalMode ? process.env.REACT_APP_LOCATION_NAME : '';




